module.exports = __webpack_public_path__ + "img/modal-1-mock.bb30ddbc.png";